import utils from '@/common/util/utils'
import {
  DEVICE_TYPE_ANDROID,
  DEVICE_TYPE_IOS,
  DEVICE_TYPE_MOBILE,
} from '@/common/devicetype.const'

export const webViewHelper = () => {
  /**
   * get device type
   * @returns {*|string}
   */
  const getDevice = () => {
    const safeDeviceList = [
      DEVICE_TYPE_MOBILE,
      DEVICE_TYPE_ANDROID,
      DEVICE_TYPE_IOS,
    ]
    const currentDevice = utils?.cookies?.getDevice()

    return safeDeviceList.includes(currentDevice)
      ? currentDevice
      : DEVICE_TYPE_MOBILE
  }

  /**
   * app close
   */
  const appClose = () => {
    location.href = 'captvpooq://webclose'
  }

  return {
    getDevice,
    appClose,
  }
}
